export function Intro() {
    return (
        <p className="text-sm text-gray-500">These promotions are shown on the screen of the on-vehicle reader</p>
    );
}

export default Intro;